(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aadya-behaviour"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root) {
    root.querySelectorAll('.mobile-nav').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      nav.addEventListener('keydown', e => {
        if (e.key === 'Escape') { nav.open = false; nav.querySelector('summary').focus(); }
      });
      document.addEventListener('click', e => { if (!nav.contains(e.target)) nav.open = false; });
    });
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const panels = [...gallery.querySelectorAll('[data-media-panel]')];
      const thumbs = [...gallery.querySelectorAll('[data-media-thumb]')];
      const show = id => {
        panels.forEach(panel => {
          panel.hidden = panel.dataset.mediaPanel !== id;
          if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
        });
        thumbs.forEach(thumb => thumb.setAttribute('aria-current', String(thumb.dataset.mediaThumb === id)));
      };
      if (panels.length) show(panels[0].dataset.mediaPanel);
      thumbs.forEach(thumb => thumb.addEventListener('click', e => { e.preventDefault(); show(thumb.dataset.mediaThumb); }));
      gallery.addEventListener('aadya:media', e => { if (panels.some(p => p.dataset.mediaPanel === e.detail)) show(e.detail); });
    });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const select = section.querySelector('[data-variant-select]');
      const update = () => {
        if (!select) return;
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-compare-price]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        const add = section.querySelector('[data-add-button]');
        add.disabled = !available;
        add.textContent = available ? add.dataset.addLabel : add.dataset.unavailableLabel;
        const status = section.querySelector('[data-availability]');
        status.textContent = available ? status.dataset.availableLabel : status.dataset.unavailableLabel;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
        section.querySelector('[data-gallery]')?.dispatchEvent(new CustomEvent('aadya:media', {detail: option.dataset.media}));
      };
      select?.addEventListener('change', update);
      if (select) update();
    });
    root.querySelectorAll('[data-zoom-link]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', e => {
        const dialog = document.querySelector('[data-image-dialog]');
        if (!dialog?.showModal) return;
        e.preventDefault();
        const img = dialog.querySelector('[data-zoom-image]');
        img.src = link.href;
        img.alt = link.querySelector('img')?.alt || '';
        dialog.showModal();
      });
    });
    root.querySelectorAll('[data-dialog-close]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => button.closest('dialog').close());
    });
    root.querySelectorAll('[data-enquiry-piece]').forEach(input => {
      const piece = new URLSearchParams(window.location.search).get('piece');
      if (piece && !input.value) input.value = piece.slice(0, 500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
